import { PaperPlaneRightIcon } from '@phosphor-icons/react'
import { ScoopText, ScoopColumn } from '../../../../../../ui'
import styles from './FollowUpPrompts.module.scss'

export const FollowUpPrompts = ({ prompts, onSendFollowUp, isProcessing }) => {
    if (!prompts || prompts.length === 0) return null

    return (
        <ScoopColumn className={styles.container}>
            <ScoopText className={styles.title}>Suggested follow-ups:</ScoopText>
            <ScoopColumn className={styles.promptsContainer}>
                {prompts.map((prompt, i) => {
                    // Handle both object format {prompt: "text"} and string format "text"
                    const promptText = typeof prompt === 'string' ? prompt : prompt.prompt
                    return (
                        <div
                            key={i}
                            onClick={() => !isProcessing && onSendFollowUp(promptText)}
                            className={`${styles.promptItem} ${isProcessing ? styles.disabled : styles.active}`}
                        >
                            <ScoopText className={styles.promptText}>{promptText}</ScoopText>
                            <PaperPlaneRightIcon
                                size={14}
                                color={isProcessing ? styles.colorDisabled : styles.colorPrimary}
                                className={styles.icon}
                            />
                        </div>
                    )
                })}
            </ScoopColumn>
        </ScoopColumn>
    )
}
